import { shortOps } from '../sx/src/lib/utils.js'
// import stdlib from '../sx/stdlib/stdlib.sx.js'
import { projectFunctions } from '../contexts/IDEContext.js'
// eslint-disable-next-line no-unused-vars
export default function provideCompletionItems(document, position, token, context) {
    var word = document.getWordUntilPosition(position);
    var range = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn,
    };
    var suggestions = [
        // {
        //     label: "import",
        //     kind: monaco.languages.CompletionItemKind.Keyword,            insertText: `import 'stdlib'\n`,
        //     range
        // },
        {
            label: "repeat",
            kind: monaco.languages.CompletionItemKind.Keyword,            insertText: 'repeat',
            range
        },
        {
            label: "break",
            kind: monaco.languages.CompletionItemKind.Keyword,            insertText: 'break',
            range
        },
        {
            label: "end",
            kind: monaco.languages.CompletionItemKind.Keyword,            insertText: 'end',
            range
        },
        {
            label: "pushCodeData",
            kind: monaco.languages.CompletionItemKind.Function,            insertText: 'pushCodeData funcOrMacroName',
            range
        },
    ];
    shortOps.map(o=>{
        //console.log(o)
        suggestions.push({
            label: o.value,
            kind: monaco.languages.CompletionItemKind.Keyword,     
            insertText: `${o.value}`,
            range
        })
    })
    // Object.keys(stdlib).map(macro => {
    //     suggestions.push({
    //         label: macro,
    //         kind: monaco.languages.CompletionItemKind.Function,          
    //         insertText: `${macro}`,
    //         range
    //     })
    // })
    projectFunctions.map(func => {
        suggestions.push({
            label: func?.name || '',
            kind: monaco.languages.CompletionItemKind.Function,          
            insertText: `${func?.name}`,
            range
        })
    })
    const validSuggestions = suggestions.filter(s => 
        s?.label && 
        s?.insertText && 
        s?.insertText !== 'undefined'
      );
      
    return { suggestions: validSuggestions }
}
